module.exports = __webpack_public_path__ + "static/media/Wilcon.c08266ab.png";